import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    zIndex: 24,
    position: 'relative',
    height: '100vh',
    minWidth: 200,
    maxWidth: 200,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[9],
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  content: {
    overflowY: 'auto',
    height: '100%',
    padding: 15,
    paddingLeft: 0,
    paddingRight: 0,
    scrollBehavior: 'smooth',
    '&::-webkit-scrollbar': {
      width: theme.shape.scrollSize,
      height: theme.shape.scrollSize,
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.scroll,
      borderRadius: theme.shape.scrollRadius,
    },
  },
  contentPendentTabs: {
    '& .title': {
      padding: '15px',
      borderTop: `2px solid ${theme.palette.scroll}`,
      paddingBottom: '0px',
    },
    '& .content': {
      overflowY: 'auto',
      maxHeight: 100,
      height: 'max-content',
      minHeight: 90,
      padding: 15,
      paddingLeft: 0,
      paddingRight: 0,
      scrollBehavior: 'smooth',
      '&::-webkit-scrollbar': {
        width: 0,
        height: 0,
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: theme.palette.scroll,
        borderRadius: theme.shape.scrollRadius,
      },
      '&:hover': {
        '&::-webkit-scrollbar': {
          width: theme.shape.scrollSize,
          height: theme.shape.scrollSize,
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: theme.palette.scroll,
          borderRadius: theme.shape.scrollRadius,
        },
      },
    },
  },
  filters: {
    width: '100%',
    boxShadow: theme.shadows[12],
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: (useStylesParams) =>
      useStylesParams.size === 'small' ? 'column' : 'row',
    // height: 49,
    transition: 'all 200ms ease-in-out',
    '& .description': {
      display: 'none',
    },
    '&:hover': {
      '& .description': {
        display: 'block',
      },
    },
  },
  filterButton: {
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '34%',
    paddingTop: 15,
    paddingBottom: 10,
    transition: 'all 200ms ease-in-out',
    '&:hover': {
      backgroundColor: theme.palette.divider,
    },
    '& * ': {
      color: theme.palette.hover3,
    },
  },
  filterButtonActive: {
    cursor: 'pointer',
    display: 'flex',
    width: '34%',
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: 15,
    paddingBottom: 10,
    backgroundColor: theme.palette.primary.main,
    '& * ': {
      color: '#fff',
    },
  },
  filterContent: {
    padding: 10,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  filterIcons: {
    display: 'flex',
    alignItems: 'center',
    margin: 0,
    padding: 0,
    marginLeft: 5,
    marginBottom: 2,
  },
  filterButtonIcon: {
    fontSize: 20,
  },
  fixedContainer: {
    width: '100%',
  },
  floatButton: {
    position: 'absolute',
    marginTop: '-60px',
    marginLeft: (useStylesParams) =>
      useStylesParams.size === 'small'
        ? 'calc(100% - 60px)'
        : 'calc(100% - 70px)',
    zIndex: 25,
    backgroundColor: theme.palette.primary.main,
    color: '#fff',
    borderRadius: '50%',
    width: 50,
    height: 50,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: theme.shadows[9],
    cursor: 'pointer',
    transition: 'all 200ms ease-in-out',
    opacity: (useStylesParams) => (useStylesParams.size === 'small' ? 0.7 : 1),
    '&:hover': {
      opacity: 1,
      backgroundColor: (useStylesParams) =>
        useStylesParams.size === 'small' ? '' : theme.palette.primary.dark,
    },
    '& svg': {
      transform: 'rotateY(180deg)',
    },
  },
}))

export default useStyles
